// Name edit modal — the Settings-tab half of display-name editing; the
// other half is the chat-side capture (utils.name_capture on the backend).
import { useState } from 'react'
import type { FormEvent } from 'react'
import { profileApi } from '../../api/profile'
import { messageFromError } from '../../api/client'
import { toast } from '../../store/toastStore'
import styles from './Settings.module.css'

const MAX_NAME = 50

export default function NameModal({
  current,
  onClose,
  onSaved,
}: {
  current: string
  onClose: () => void
  onSaved: (name: string) => void
}) {
  const [name, setName] = useState(current)
  const [saving, setSaving] = useState(false)

  const submit = async (e: FormEvent) => {
    e.preventDefault()
    const trimmed = name.trim()
    if (!trimmed) return toast('Введите имя', 'error')
    if (trimmed === current) return onClose()
    setSaving(true)
    try {
      await profileApi.updateDisplayName(trimmed)
      toast('Имя обновлено', 'success')
      onSaved(trimmed)
      onClose()
    } catch (err) {
      toast(messageFromError(err, 'Не удалось сохранить имя'), 'error')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalCard} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h3>Имя</h3>
          <button className={styles.modalClose} onClick={onClose}>✕</button>
        </div>
        <form className={styles.form} onSubmit={submit}>
          <input
            className={styles.input}
            type="text"
            placeholder="Как к вам обращаться"
            maxLength={MAX_NAME}
            autoFocus
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <button className={styles.primaryBtn} type="submit" disabled={saving}>
            {saving ? 'Сохранение...' : 'Сохранить'}
          </button>
        </form>
      </div>
    </div>
  )
}
